import React from 'react';
import { ProgressRing } from './ProgressRing';
import { ClockIcon, HelpCircleIcon, BookOpenIcon, CalendarIcon } from './icons/InterfaceIcons';

const getTagColor = (tag) => {
    switch (tag) {
        case 'New': return 'bg-brand-accent-amber/10 text-brand-accent-amber';
        case 'Recommended': return 'bg-brand-secondary/10 text-brand-secondary';
        case 'Past Year': return 'bg-gray-400/10 text-gray-500';
        case 'Adaptive': return 'bg-brand-accent-violet/10 text-brand-accent-violet';
        default: return 'bg-gray-100 text-brand-text-secondary';
    }
};


// FIX: Add explicit types for props to allow 'key' prop in map.
export const MockTestCard: React.FC<{ test: any; onStartTest?: (testId: any) => void }> = ({ test, onStartTest }) => {
    const hasBeenAttempted = test.attempts > 0 && typeof test.bestScore !== 'undefined';
  
    return (
    <div className="group bg-brand-surface border border-brand-border rounded-2xl p-5 flex flex-col space-y-4 transition-all duration-300 ease-in-out hover:border-brand-primary hover:shadow-card-hover hover:-translate-y-1">
      {/* Card Header */}
      <div className="flex items-start justify-between">
        <h3 className="font-bold text-lg text-brand-text-primary pr-4 flex-1">{test.name}</h3>
        <div className="flex-shrink-0 flex items-center gap-2">
            {test.tags.map(tag => (
                <span key={tag} className={`text-xs font-semibold px-2.5 py-1 rounded-full ${getTagColor(tag)}`}>
                    {tag}
                </span>
            ))}
        </div>
      </div>

      {/* Stats and Progress */}
      <div className="flex items-center justify-between">
        <div className="flex flex-col space-y-2 text-sm text-brand-text-secondary">
            <div className="flex items-center space-x-1.5"><HelpCircleIcon className="w-4 h-4"/><span>{test.questions} questions</span></div>
            <div className="flex items-center space-x-1.5"><ClockIcon className="w-4 h-4"/><span>{test.duration} mins</span></div>
            <div className="flex items-center space-x-1.5"><BookOpenIcon className="w-4 h-4"/><span>{test.type}</span></div>
        </div>
        {hasBeenAttempted && (
            <div className="text-center">
                <ProgressRing progress={test.bestScore} size={64} strokeWidth={6} />
                <p className="text-xs text-brand-text-secondary mt-1">Best Score</p>
            </div>
        )}
      </div>

      {/* Stats Footer */}
      {hasBeenAttempted && (
          <div className="flex justify-around text-center text-xs text-brand-text-secondary border-t border-brand-border pt-3">
              <div>
                  <p className="font-bold text-sm text-brand-text-primary">{test.attempts}</p>
                  <p>Attempts</p>
              </div>
              <div>
                  <p className="font-bold text-sm text-brand-text-primary">{test.avgTime || 'N/A'}</p>
                  <p>Avg. Time</p>
              </div>
          </div>
      )}

      {/* Action Buttons */}
      <div className="pt-2 flex flex-col sm:flex-row items-center space-y-2 sm:space-y-0 sm:space-x-2">
        <button 
          onClick={() => onStartTest?.(test.id)}
          className="w-full bg-indigo-gradient text-white font-bold py-3 px-4 rounded-lg transition-all duration-300 hover:opacity-90 cursor-pointer"
        >
          {test.attempts > 0 ? 'Re-attempt' : 'Start Test'}
        </button>
        <div className="w-full sm:w-auto flex space-x-2">
            {hasBeenAttempted && (
                <button className="w-full sm:w-auto flex-1 text-sm font-semibold py-3 px-4 rounded-lg bg-brand-primary/10 hover:bg-brand-primary/20 text-brand-primary transition-colors cursor-pointer">
                    Review
                </button>
            )}
            <button title="Schedule Later" className="p-3 rounded-lg bg-brand-surface hover:bg-brand-bg dark:bg-gray-100 dark:hover:bg-gray-200 text-brand-text-secondary transition-colors cursor-pointer">
                <CalendarIcon className="w-5 h-5" />
            </button>
        </div>
      </div>
    </div>
  );
};